/* http-signature/lib/index */ function _(require, module, exports) {
    // Copyright 2015 Joyent, Inc.
    var parser = require(137) /* ./parser */;
    var signer = require(138) /* ./signer */;
    var verify = require(140) /* ./verify */;
    var utils = require(139) /* ./utils */;
    ///--- API
    module.exports = {
        parse: parser.parseRequest,
        parseRequest: parser.parseRequest,
        sign: signer.signRequest,
        signRequest: signer.signRequest,
        createSigner: signer.createSigner,
        isSigner: signer.isSigner,
        sshKeyToPEM: utils.sshKeyToPEM,
        sshKeyFingerprint: utils.fingerprint,
        pemToRsaSSHKey: utils.pemToRsaSSHKey,
        verify: verify.verifySignature,
        verifySignature: verify.verifySignature,
        verifyHMAC: verify.verifyHMAC
    };
}
